export default{
    signIn: "登录",
    signOut: "登出",
    enter: "进入",
    submit: "提交",
    clickToEnter: "点击进入"
}